import React from 'react';
import { Sun, Moon, Desktop } from '@phosphor-icons/react';
import { NavItem, LanguageOption, ThemeOption } from '../types';

// Navigation items
// Order: Ask, Upload, Record, Files, Collections
// Search, Tasks, People, and Admin are filtered for non-super admins in IntakeLeftMenu
// Organization and Templates are now in the organization section
export const NAVIGATION_ITEMS: NavItem[] = [
  { label: 'Ask', icon: 'Psychology', path: '/ai-chat' },
  { label: 'Upload', icon: 'PlusCircle', path: '/create/upload' },
  { label: 'Record', icon: 'Mic', path: '/create/record' },
  { label: 'Files', icon: 'Files', path: '/records' },
  { label: 'Folders', icon: 'FoldersIcon', path: '/collections' },
  { label: 'Search', icon: 'MagnifyingGlass', path: '/search', isAction: true },
  { label: 'Tasks', icon: 'CheckSquare', path: '/tasks' },
  { label: 'People', icon: 'Users', path: '/people' },
  { label: 'Admin', icon: 'ShieldCheck', path: '/admin' }
];

// Language options
export const LANGUAGES: LanguageOption[] = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' }
];

// Theme options
export const THEME_OPTIONS: ThemeOption[] = [
  {
    value: 'light',
    label: 'Light',
    icon: React.createElement(Sun, { size: 18, weight: 'regular' })
  },
  {
    value: 'dark',
    label: 'Dark',
    icon: React.createElement(Moon, { size: 18, weight: 'regular' })
  },
  { 
    value: 'system', 
    label: 'System',
    icon: React.createElement(Desktop, { size: 18, weight: 'regular' })
  }
];

// Drawer constants
export const DRAWER_CONFIG = {
  MIN_WIDTH: 231, // Set to exact measured minimum width
  MAX_WIDTH: 600,
  DEFAULT_WIDTH: 231, // Set to match minimum width
  IPAD_WIDTH: 231, // Use same width for iPad consistency
  COLLAPSED_WIDTH: 72
};

// Device detection utility
export const isIPad = () => {
  if (typeof window === 'undefined') return false;

  const userAgent = window.navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isMacOS = /Macintosh/.test(userAgent);

  // Check for iPad specifically
  if (/iPad/.test(userAgent)) return true;

  // Check for iPad Pro running iOS 13+ (reports as Mac)
  if (isMacOS && 'ontouchend' in document) return true;

  // Check for screen dimensions typical of iPad
  if (isIOS || isMacOS) {
    const { width, height } = window.screen;
    const maxDimension = Math.max(width, height);
    const minDimension = Math.min(width, height);

    // iPad dimensions: 768x1024 (standard), 834x1194 (Air), 1024x1366 (Pro)
    return (
      (minDimension >= 768 && maxDimension >= 1024) ||
      (minDimension >= 834 && maxDimension >= 1194) ||
      (minDimension >= 1024 && maxDimension >= 1366)
    );
  }

  return false;
};
